import config from '../../../config';

export const openUploadWidget = (callback) => {
  const widget = window.cloudinary.createUploadWidget({
    cloudName: config.cloudName, 
    uploadPreset: config.uploadPreset, 
    multiple: false,
    sources: ['local', 'url']
   },
    (error, result) => { callback(error, result); 
  });
  widget.open();
};